export const tickerItems = [
  "平台方深夜发布处理公告：涉事账号限流三十天",
  "第二段录音流出，提及一笔“数据维护”费用",
  "剧组“天价片酬”风波再起，制片方连夜回应",
  "监控画面曝光，某商圈纠纷细节出现关键反转",
  "品牌方晒出打款凭证，回应“拖欠”传闻",
  "属地监管部门表示已关注舆情，正在依法核实",
];

export const heroLead = {
  tag: "今日焦点",
  title: "某头部主播直播间“刷单返现”录音外泄 三方各执一词",
  summary:
    "一段时长约七分钟的录音于今日凌晨在网络流传，内容牵出品牌方、MCN 机构与主播团队之间的分成争议。截至发稿，涉事三方均已发布书面回应，事件仍在持续更新中。",
  time: "2 小时前",
  heat: "128.6 万",
  source: "综合报道",
  image:
    "https://readdy.ai/api/search-image?query=Abstract%20editorial%20newsroom%20concept%20with%20dramatic%20spotlight%20beams%20over%20deep%20warm%20crimson%20background%2C%20blurred%20silhouettes%20of%20hands%20reaching%20toward%20a%20microphone%2C%20stylized%20scattered%20paper%20documents%2C%20fine%20film%20grain%20texture%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%2C%20warm%20vermillion%20and%20amber%20tones%2C%20no%20readable%20text%2C%20magazine%20cover%20art%20style&width=900&height=680&seq=wangbao-hero-lead-2026&orientation=landscape",
};

export const heroSecondary = [
  {
    tag: "后续瓜",
    title: "剧组“天价片酬”风波再起 制片方连夜发声明",
    summary:
      "有自称剧组工作人员的账号晒出部分合同截图，称主演片酬占制作成本近四成。制片方回应称截图“不完整、存在误导”。",
    time: "3 小时前",
    heat: "96.2 万",
  },
  {
    tag: "新证据",
    title: "监控片段曝光 某商圈纠纷细节出现关键反转",
    summary:
      "一段未剪辑的监控画面被公开，画面显示事发前双方曾有一次未被提及的会面，为事件走向埋下新的疑问。",
    time: "4 小时前",
    heat: "88.1 万",
  },
  {
    tag: "官方通报",
    title: "平台方发布处理公告 涉事账号被限流三十天",
    summary:
      "公告指出相关账号涉嫌发布未经核实的信息，违反社区规范，同时要求当事方补充完整证据材料。",
    time: "5 小时前",
    heat: "74.5 万",
  },
  {
    tag: "追踪",
    title: "品牌方晒出打款凭证 回应“拖欠”传闻",
    summary:
      "品牌方公开三笔银行回单与对账明细，称款项已按合同节点结清，反指合作方存在数据造假行为。",
    time: "6 小时前",
    heat: "63.8 万",
  },
];

export const updateFilters = ["全部", "进展", "证据", "通报", "后续瓜"];

export const latestUpdates = [
  {
    id: "u-01",
    tag: "进展",
    title: "涉事 MCN 机构首次正面回应：合作合同为“框架协议”",
    summary:
      "机构法务称双方签署的是框架协议，具体分成以补充条款为准，目前已委托律师固定证据，并将配合后续核查。",
    time: "08:40",
    source: "综合报道",
    heat: "82.4 万",
    isNew: true,
  },
  {
    id: "u-02",
    tag: "证据",
    title: "第二段录音出现 内容涉及一笔“数据维护”费用",
    summary:
      "新曝光的录音中提及一笔用于“数据维护”的支出，金额与此前流出的对账单高度接近，真实性仍待核实。",
    time: "07:25",
    source: "网友整理",
    heat: "77.9 万",
    isNew: true,
  },
  {
    id: "u-03",
    tag: "通报",
    title: "属地监管部门表示已关注舆情 正在依法核实",
    summary:
      "工作人员回应称已收到多方反映，正在依法依规核实相关情况，后续处理意见将以正式通报为准。",
    time: "06:50",
    source: "官方渠道",
    heat: "69.3 万",
    isNew: false,
  },
  {
    id: "u-04",
    tag: "追踪",
    title: "当事主播取消两场直播 团队称“正常调整排期”",
    summary:
      "原定于今晚上线的两场带货直播被临时取消，团队未正面回应是否与本次风波相关。",
    time: "05:30",
    source: "综合报道",
    heat: "58.1 万",
    isNew: false,
  },
  {
    id: "u-05",
    tag: "后续瓜",
    title: "合作品牌连夜下架联名商品 页面已无法访问",
    summary:
      "多个电商平台的联名商品链接显示“商品已下架”，品牌客服未对下架原因作出说明。",
    time: "04:10",
    source: "网友爆料",
    heat: "52.6 万",
    isNew: false,
  },
  {
    id: "u-06",
    tag: "进展",
    title: "律师解读：录音作为证据需经完整性鉴定",
    summary:
      "有律师指出，录音作为证据需保证未经过剪辑，当事人可申请司法鉴定确认其真实性与完整程度。",
    time: "02:45",
    source: "媒体连线",
    heat: "44.2 万",
    isNew: false,
  },
  {
    id: "u-07",
    tag: "追踪",
    title: "话题阅读量破六亿 相关词条连登热榜前列",
    summary:
      "截至今日上午，相关话题累计阅读量突破六亿，多个关联词条同时出现在热搜榜前列位置。",
    time: "01:20",
    source: "数据统计",
    heat: "39.8 万",
    isNew: false,
  },
  {
    id: "u-08",
    tag: "证据",
    title: "一份未公开的补充协议被翻拍流出",
    summary:
      "协议翻拍件显示双方曾约定阶梯式分成，其中一档的结算条件成为本次争议的核心焦点。",
    time: "昨日 23:15",
    source: "网友整理",
    heat: "35.4 万",
    isNew: false,
  },
  {
    id: "u-09",
    tag: "通报",
    title: "行业协会发文提示规范直播带货合作流程",
    summary:
      "提示要求机构与主播签订书面合同、明确数据归属，并妥善保留完整的结算凭证备查。",
    time: "昨日 21:40",
    source: "官方渠道",
    heat: "28.7 万",
    isNew: false,
  },
  {
    id: "u-10",
    tag: "后续瓜",
    title: "知情人称双方曾三次谈判未果 争议金额达七位数",
    summary:
      "一名接近事件的人士透露，双方在分成比例上分歧较大，谈判多次中断，至今未达成一致。",
    time: "昨日 19:05",
    source: "媒体连线",
    heat: "24.1 万",
    isNew: false,
  },
];

export const hotRanking = [
  { rank: 1, title: "主播录音外泄事件持续发酵", heat: "128.6 万", trend: "up" },
  { rank: 2, title: "剧组天价片酬风波再起", heat: "96.2 万", trend: "up" },
  { rank: 3, title: "商圈纠纷监控画面曝光", heat: "88.1 万", trend: "same" },
  { rank: 4, title: "平台处理公告引发热议", heat: "74.5 万", trend: "up" },
  { rank: 5, title: "品牌方晒打款凭证回应", heat: "63.8 万", trend: "down" },
  { rank: 6, title: "联名商品连夜下架", heat: "52.6 万", trend: "up" },
  { rank: 7, title: "第二段录音流出", heat: "47.3 万", trend: "up" },
  { rank: 8, title: "监管部门已关注舆情", heat: "39.8 万", trend: "same" },
  { rank: 9, title: "补充协议翻拍件流出", heat: "35.4 万", trend: "up" },
  { rank: 10, title: "行业协会发规范提示", heat: "28.7 万", trend: "down" },
];

export const timelineEvents = [
  {
    id: "t-01",
    date: "09-10",
    time: "08:12",
    tag: "最新",
    title: "涉事机构发布书面回应 称录音“存在剪辑痕迹”",
    desc: "机构法务团队在声明中表示，已委托专业机构对录音完整性进行鉴定，并将视鉴定结果决定后续动作。",
    official: false,
  },
  {
    id: "t-02",
    date: "09-10",
    time: "06:40",
    tag: "进展",
    title: "品牌方启动内部核查 客服口径统一",
    desc: "品牌方客服表示，已就合作流程与结算记录展开内部核查，核实完成后会通过官方渠道公布结果。",
    official: false,
  },
  {
    id: "t-03",
    date: "09-10",
    time: "05:15",
    tag: "追踪",
    title: "知情人：双方三次谈判未果",
    desc: "据接近事件人士透露，争议焦点集中在阶梯分成的结算条件上，谈判一度中断后未再重启。",
    official: false,
  },
  {
    id: "t-04",
    date: "09-10",
    time: "03:02",
    tag: "证据",
    title: "第二段录音在网络流传",
    desc: "新录音提及一笔“数据维护”费用，与此前流出的对账单金额接近，真实性有待进一步核实。",
    official: false,
  },
  {
    id: "t-05",
    date: "09-09",
    time: "23:50",
    tag: "起点",
    title: "首段录音流出 话题迅速登上热榜",
    desc: "一段约七分钟的录音在多个平台快速扩散，相关话题在数小时内冲上热榜前列。",
    official: false,
  },
  {
    id: "t-06",
    date: "09-09",
    time: "22:30",
    tag: "通报",
    title: "当事主播暂停两场直播排期",
    desc: "团队对外称系“正常调整排期”，并未正面回应是否与本次风波相关。",
    official: true,
  },
];

export const officialNotices = [
  {
    org: "平台治理中心",
    title: "关于对相关账号作出限流处理的公告",
    date: "09-10",
    summary:
      "经核查，相关账号涉嫌发布未经核实的信息，扰乱社区秩序。现作出限流三十天的处理，并要求当事方在限期内补充完整证据材料。",
  },
  {
    org: "行业协会",
    title: "关于规范直播带货合作流程的提示",
    date: "09-09",
    summary:
      "提示会员单位与从业人员签订书面合作合同，明确数据归属与结算方式，妥善保存完整凭证，避免后续产生争议。",
  },
  {
    org: "属地监管部门",
    title: "已关注相关舆情 正在依法核实",
    date: "09-09",
    summary:
      "工作人员表示已收到多方反映，正在依法依规核实情况，调查结果及处理意见将以正式通报发布为准。",
  },
];

export const evidenceItems = [
  {
    tag: "画面证据",
    title: "三段无剪辑监控片段",
    summary:
      "画面完整记录了事发前后的连续过程，其中一段显示双方曾在非公开场合会面，时间线与公开说法存在出入。",
    date: "09-10",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20close%20up%20of%20a%20surveillance%20monitor%20screen%20showing%20a%20blurred%20city%20street%20scene%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20fine%20film%20grain%2C%20cinematic%20vignette%2C%20investigative%20journalism%20concept%20art%2C%20soft%20scan%20lines%2C%20no%20readable%20text%2C%20high%20detail&width=700&height=500&seq=wangbao-evidence-cctv-2026&orientation=landscape",
  },
  {
    tag: "资金证据",
    title: "三笔银行回单与对账明细",
    summary:
      "品牌方公开的凭证显示款项已按合同节点结清，与外界流传的“拖欠”说法存在明显出入。",
    date: "09-10",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20lay%20of%20blank%20financial%20receipt%20papers%20and%20a%20calculator%20on%20a%20warm%20cream%20desk%20surface%2C%20soft%20natural%20light%2C%20minimal%20editorial%20still%20life%2C%20muted%20vermillion%20accent%20marks%2C%20all%20text%20blurred%20and%20unreadable%2C%20gentle%20shadows%2C%20high%20detail&width=700&height=500&seq=wangbao-evidence-receipt-2026&orientation=landscape",
  },
  {
    tag: "文本证据",
    title: "一份未公开的补充协议",
    summary:
      "协议翻拍件显示双方曾约定阶梯式分成，其中一档的结算条件成为本次争议的核心焦点。",
    date: "09-09",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20still%20life%20of%20a%20stack%20of%20paper%20documents%20with%20redacted%20black%20bars%20and%20a%20pen%2C%20warm%20neutral%20beige%20background%2C%20soft%20studio%20lighting%2C%20minimal%20investigative%20mood%2C%20editorial%20photography%20style%2C%20no%20readable%20text%2C%20subtle%20shadows%2C%20high%20detail&width=700&height=500&seq=wangbao-evidence-document-2026&orientation=landscape",
  },
];

export const topicEntries = [
  {
    name: "直播带货纠纷",
    desc: "合同、分成与数据归属的完整脉络",
    count: "128 篇",
    icon: "ri-live-line",
  },
  {
    name: "剧集片酬追踪",
    desc: "从合同截图到片方回应的全过程",
    count: "86 篇",
    icon: "ri-clapperboard-line",
  },
  {
    name: "品牌维权合集",
    desc: "结算凭证、声明与平台处理汇总",
    count: "64 篇",
    icon: "ri-shield-check-line",
  },
  {
    name: "平台治理观察",
    desc: "限流、通报与行业规范的动态",
    count: "52 篇",
    icon: "ri-government-line",
  },
];

export const faqItems = [
  {
    q: "网曝黑料的最新进展多久更新一次？",
    a: "进展类内容全天滚动更新，通常在两小时内同步一次；官方通报一经发布，我们会第一时间在“官方通报”栏目同步，确保读者不会错过关键节点。",
  },
  {
    q: "“官方通报”栏目和普通爆料有什么区别？",
    a: "官方通报只收录监管部门、平台方或行业协会等权威渠道公开发布的信息，并完整标注来源与时间，不掺杂个人观点与推测。",
  },
  {
    q: "如何第一时间收到后续瓜的更新提醒？",
    a: "在客户端开启“订阅追踪”，选择关注的事件或专题后，有新进展时会在第一时间推送提醒，也可以按主题批量订阅。",
  },
  {
    q: "平台上的信息都是真实的吗？如何辨别？",
    a: "内容多为公开信息的聚合整理，我们会标注来源与核实状态。建议以官方通报为准，对尚未证实的说法保持谨慎，理性看待每一条线索。",
  },
  {
    q: "可以投稿或提供线索吗？",
    a: "可以通过客户端内的“线索入口”提交材料，我们会先做初步核实；涉及个人隐私的信息将依法处理，也请勿提交未经证实的指控。",
  },
];

export const footerColumns = [
  {
    title: "内容导航",
    links: ["最新进展", "后续瓜", "新证据", "官方通报", "实时热度榜"],
  },
  {
    title: "追踪专题",
    links: ["直播带货纠纷", "剧集片酬追踪", "品牌维权合集", "平台治理观察"],
  },
  {
    title: "关于与帮助",
    links: ["关于我们", "联系方式", "版权声明", "免责声明", "常见问题"],
  },
];